module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "The Law and the Constitution"
    }
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/text/Contents#rch1"
    }
  }, [_vm._v("The Law and the Constitution")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CONSIDER MYSELF")]), _vm._v(" an originalist, but let me distinguish another kind. Another kind would say, “Judges do not have the power to make law. That’s given to the legislature. And to make sure that the judges are not infusing their own beliefs and ideas into the constitutional text, we have to read it literally. We have to cast our minds back over more than two centuries and try to divine how the founding fathers or the authors of the Fourteenth Amendment . . . would decide that.” I say, “That’s exactly what I’m doing, but I’m putting those men—and they were all men who wrote the Constitution—with us today.” And I know that Thomas Jefferson, who prized equality so much but was himself a slave owner, would applaud how that idea of equality has expanded over the decades.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("The Aaron Harber Show")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE FOUNDING FATHERS")]), _vm._v(" thought in the natural rights vein. Human rights, in their view, antedated the state (or nation). They were given by Higher Authority. They were not the government’s to confer. Rather, the government was to be kept from trampling on them.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—University of Arkansas at Little Rock School of Law, February 7, 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTITUTION WAS")]), _vm._v(" a remarkable institution. After all, what it did was it rejected the patriarchal power of kings, and it said that people’s fortune in the United States was not going to turn on birth status. Those ideas have tremendous growth potential.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—American Enterprise Institute, April 19, 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RYING TO DIVINE")]), _vm._v(" what the Framers intended, I must look at that matter two ways. One is what they might have intended immediately for their day, and the other is their larger expectation that the Constitution would govern, as [Justice Benjamin] Cardozo said, not for the passing hour, but for the expanding future.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—confirmation hearings before the Senate Committee on the Judiciary, July 1993")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F")]), _vm._v(" I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WERE")]), _vm._v(" in a state ratifying convention, I would propose including explicitly in the Bill of Rights . . . the basic statement in the Declaration of Independence that all persons are equally entitled to fundamental human rights. That’s the one guarantee that is central to the Declaration of Independence, the equality guarantee, but is missing from the 1787 Constitution and from the Bill of Rights.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—American Enterprise Institute, April 19, 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT MAY SEEM")]), _vm._v(" constitutional in the abstract may be revealed as unconstitutional when viewed in a specific, contemporary world context—a context that the legislators who passed the law foresaw only dimly, if at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Paul M. Hebert Law Center, October 24, 1996")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE LAW EXISTS")]), _vm._v(" to govern a society. The law exists in the service of a society. So the experience of the society of course is going to be reflected in the law. If the law is aridly logical, it has nothing to do with the way people live, it’s not going to be a successful regime.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—92nd Street Y, September 26, 2017")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE WORD THAT")]), _vm._v(" is never used in the Constitution is “slavery,” but it was the burning problem. And the original Constitution has certain imperfections. One of them is, in the very first article, the slave trade was allowed to continue until the year 1808. . . . Our original Constitution doesn’t have any equality provision in it because some humans were held in bondage by other humans. Our Constitution didn’t get perfected in that regard until after the Civil War.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Annenberg Classroom, December 2006")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F YOU WERE")]), _vm._v(" writing a Constitution today, would you look back to an eighteenth-century model and not consider newer constitutions?")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Yale Law School, 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" US C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSTITUTION")]), _vm._v(" is nearly 220 years old and contains no express provision opposing discrimination on the basis of gender. Equal protection jurisprudence in the United States involves interpretation of the spare command that governing authorities shall not deny to any person “the equal protection of the laws.” Those words, inserted into the US Constitution in 1868, were once interpreted narrowly, but over time, they proved to have growth potential.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—University of Cape Town, South Africa, February 10, 2006")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERY MODERN HUMAN")]), _vm._v(" rights document has a statement that men and women are equal before the law. Our Constitution doesn’t. I would like to see, for the sake of my daughter and my granddaughter and all the daughters who come after, that statement as part of our fundamental instrument of Government.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—confirmation hearings before the Senate Committee on the Judiciary, July 1993")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ADOPTION OF")]), _vm._v(" the equal rights amendment would relieve the Court’s uneasiness in the gray zone between interpretation and amendment of the Constitution. It would remove the historical impediment—the absence of any intention by eighteenth and nineteenth century Constitution makers to deal with gender-based discrimination. It would add to our fundamental instrument of government a principle under which the judiciary may develop the coherent opinion pattern lacking up to now. It also should end the legislative inertia that retards social change by keeping obsolete disciminatory laws on the books.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("American Bar Association Journal")]), _vm._v(", January 1977")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THEORY, THE")]), _vm._v(" job [of giving men and women equal rights] could be done without an equal rights amendment. But history strongly suggests that the task will continue to be relegated to a legislative backburner without the propelling force supplied by the ERA.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—on the Equal Rights Amendment, "), _c('i', [_vm._v("Update on Law-Related Education")]), _vm._v(", Spring 1978")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NY HUMAN RIGHTS")]), _vm._v(" guarantee that is phrased in grand, general terms is vulnerable to a scare campaign. That is what’s happening to the Equal Rights Amendment. The Equal Rights Amendment is not comparable to the amendment that says eighteen-year-olds can vote. That amendment plainly means eighteen and not seventeen. Because the ERA reads, “Equality under the law shall not be denied or abridged by the United States or by any state on account of sex,” people can distort its meaning.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("Women of Wisdom")]), _vm._v(", 1981")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTS")]), _vm._v(" Amendment is not a cure-all. It takes people who care about implementing the right to ensure that it becomes real and not just [a] paper statement.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Yale Law School, 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EASURED MOTIONS SEEM")]), _vm._v(" to me right, in the main, for constitutional as well as common law adjudication. Doctrinal limbs too swiftly shaped, experience teaches, may prove unstable.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—New York University School of Law, March 9, 1993")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T WOULD BE")]), _vm._v(" perverse to interpret the term “Legislature” in the Elections Clause so as to exclude lawmaking by the people, particularly where such lawmaking is intended to check legislators’ ability to choose the district lines they run in, thereby advancing the prospect that Members of Congress will in fact be “chosen . . . by the People of the several States.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—on the Arizona legislature’s attempt to remove districting power from a voter-appointed commission, court opinion, "), _c('i', [_vm._v("Arizona State Legislature v. Arizona Independent Redistricting Commission")]), _vm._v(", June 29, 2015")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE LEGISLATURE’S RESPONSIVENESS")]), _vm._v(" to the people its members represent is hardly heightened when the representative body can be confident that what it does will not be overturned or modified by the voters themselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—on the Arizona legislature’s attempt to remove districting power from a voter-appointed commission, court opinion, "), _c('i', [_vm._v("Arizona State Legislature v. Arizona Independent Redistricting Commission")]), _vm._v(", June 29, 2015")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("DO")]), _vm._v(" I think is enduring? “Congress shall pass no law respecting freedom of speech or of the press.” That right to speak your mind and not worry about big brother government coming down on you and telling you the right way to think, speak, and write—that’s tremendously important.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Rathbun Lecture on a Meaningful Life at Stanford University, February 6, 2017")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MENDMENT")]), _vm._v(" is outdated in the sense that its function has become obsolete. And, in my view, if the court had properly interpreted the Second Amendment, the court would have said, “That amendment was very important when the nation was new. It gave a qualified right to keep and bear arms, but it was for one purpose only, and that was the purpose of having militiamen who were able to fight to preserve the nation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("The Takeaway")]), _vm._v(", September 15, 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU CANNOT HAVE")]), _vm._v(" a death penalty that’s administered with an even hand. That’s the problem. Who gets the death penalty? It’s a roulette wheel, and that’s not a system of justice.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Smithsonian Associates, February 12, 2015")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE INCIDENCE OF")]), _vm._v(" capital punishment has gone down, down, down, so that now I think there are only three states that actually administer the death penalty. Not even whole states, but particular areas of states. It may depend on who is the district attorney. So we may see an end to capital punishment by attrition, as there are fewer and fewer executions.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Washington Council of Lawyers Summer Pro Bono and Public Interest Forum, July 24, 2017")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME THINGS THAT")]), _vm._v(" I would like to change: one is the electoral college. But that would require a constitutional amendment, which is . . . powerfully hard to do.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Rathbun Lecture on a Meaningful Life at Stanford University, February 6, 2017")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" US "), _c('span', {
    staticClass: "small"
  }, [_vm._v("JUDICIAL")]), _vm._v(" system will be the poorer, I have urged, if we do not both share our experience with, and learn from, legal systems with values and a commitment to democracy similar to our own.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—International Academy of Comparative Law, American University, July 30, 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THINK OUR")]), _vm._v(" system is notable for its transparency. We don’t pretend that the law is always clear and certain. Many times, there’s a good argument to be made on both sides on what the law is.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Duke University School of Law, July 21, 2017")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d48804","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter01.vue
// module id = 81
// module chunks = 0